var _circle, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 46.5,
    stroke: "url(#paint0_linear_34793_5118)",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.7207 47.0102L41.5661 61.8556L69.7723 33.6494",
    stroke: "url(#paint1_linear_34793_5118)",
    strokeWidth: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_34793_5118",
    x1: 96,
    y1: 21.3333,
    x2: 12.056,
    y2: 122.283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0002,
    stopColor: "#FF6534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.541518,
    stopColor: "#FF0E9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.928765,
    stopColor: "#A925FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_34793_5118",
    x1: 69.7723,
    y1: 39.9175,
    x2: 48.6955,
    y2: 78.6044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0002,
    stopColor: "#FF6534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.541518,
    stopColor: "#FF0E9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.928765,
    stopColor: "#A925FA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.9352159898f60ccd006c201517fa775f.svg";
export { ForwardRef as ReactComponent };